import { render } from "./GenericProductSorter.vue?vue&type=template&id=04edf46c&scoped=true"
import script from "./GenericProductSorter.vue?vue&type=script&lang=js"
export * from "./GenericProductSorter.vue?vue&type=script&lang=js"

import "./GenericProductSorter.vue?vue&type=style&index=0&id=04edf46c&scoped=true&lang=css"

import exportComponent from "/home/cm/project/golinker/admin-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04edf46c"]])

export default __exports__